import React, { useEffect, useState } from "react";
import i18n from 'utils/i18n'
import _ from 'lodash'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import { constantsActive, constantsGraphql } from 'utils/constants/constants'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import { listArrow } from 'styles/list'
import LoadingComponent from 'components/atoms/Loading'
import FetchDepartment from 'utils/fetch/FetchDepartment'
import ListItem from 'components/atoms/ListItem'

const CompanyDepartments = ({ company }) => {
	
	const navigation = useNavigation();
	
	const [ departments, setDepartments ] = useState( [] )
	const [ loading, setLoading ] = useState( true )
	const [ search, setSearch ] = useState( '' )
	
	const fetchDepartments = () => {
		const companyNotExists = _.get( company, 'guid', '[empty]' ) === '[empty]'

		FetchDepartment.fetchAll( {
			variables: {
				company_guid: !companyNotExists ? company.guid : '[empty]',
				active: constantsGraphql.YES_NO,
			},
			callbackSuccess: ( {departments} ) => {
				setDepartments( departments )
				setLoading( false )
			}
		} );
	}
	
	const openDepartment =  ( department ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_COMPANY_COMPANIES_DEPARTMENT, {
			departmentGuid: department.guid,
			companyGuid: company.guid,
		} );
	}
	
	const createDepartment = () => {
		openDepartment( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		const name = _.get( item, 'name', '' ).replace( `${company.name} - `, '' );
		
		return (
			<ListItem
				title={ name }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openDepartment }
			/>
		)
	}
	
	useEffect( () => {
		return fetchDepartments();
	}, [] )
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}
	
	const filters = _.size( search ) > 2 ? [ { field: 'name', kind: 'contains', value: search } ] : null;
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.company.company.input_search'),
					onChangeText: _.debounce( setSearch, 400 ),
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.DEPARTMENTS ) ? { onPress: createDepartment.bind( this ) } : null }
		/>
	);
	
	return (
		<ManagementGroupedThemeList
			header={ header }
			items={ departments }
			renderItem={ renderItem.bind( this ) }
			groupByKey={ 'active' }
			filters={ filters }
			groupByValues={ [
				constantsActive.YES,
				constantsActive.NO
			]}
		/>
	)
}

export default CompanyDepartments
